import './stylesheets/venue_nav.scss';

export default id => {
  const venueNav = document.getElementById(id);
  if (venueNav) {
    import(/* webpackChunkName: "scroll-nav" */ '@morsedigital/scroll-nav').then(({ default: ScrollNav }) => {
      ScrollNav(venueNav);

      const wrapper = document.getElementById(venueNav.getAttribute('data-wrapper'));
      const activeItem = venueNav.querySelector('.venue-nav-list__item--active');

      if (wrapper && activeItem) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        const offset = (itemRect.left + itemRect.width / 2) - (wrapperRect.left + wrapperRect.width / 2);
        wrapper.scrollLeft = Math.max(0, offset);
      }
    });
  }
};
